import { BellOutlined } from '@ant-design/icons'
import { Button, Popover } from 'antd'

import {
  useUserServiceGetMessagesCountEndpoint,
  useUserServiceGetMessagesListEndpoint
} from 'src/api/queries'
import { ONE_MINUTE_IN_MS } from 'src/app-constants'
import { useUser } from 'src/hooks'

import { NotificationsContent } from './NotificationsContent'
import { useStyles } from './styles'

export const NotificationPopover = () => {
  const { styles } = useStyles()
  const { userData } = useUser()

  const queryParams = {
    pageNumber: 1,
    pageSize: 2,
    ...(!!userData?.currentLegalEntityId && {
      legalEntityIds: [userData.currentLegalEntityId]
    })
  }

  const { data: count } = useUserServiceGetMessagesCountEndpoint()

  const { data } = useUserServiceGetMessagesListEndpoint(
    queryParams,
    [queryParams],
    {
      refetchInterval: ONE_MINUTE_IN_MS
    }
  )

  return (
    <Popover
      content={
        <NotificationsContent
          notifications={data?.data}
          notificationsCount={count?.totalCount}
        />
      }
      arrow={false}
      rootClassName={styles.popover}
    >
      <Button icon={<BellOutlined />} className={styles.button}>
        {!!count?.totalNotRead && (
          <div className={styles.count}>{count.totalNotRead}</div>
        )}
      </Button>
    </Popover>
  )
}
